<template>
    <shinsei-form />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import ShinseiForm from '@/components/shinsei/create/Form.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'shinsei-form': ShinseiForm
    }
})
</script>
